import React from "react";
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "./AuthContext";

export default function EnglishIdLayout() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();

  const doLogout = async () => {
    await logout();
    nav("/english-id/login");
  };

  return (
    <div className="min-h-screen bg-[#F6EFDF] text-[#132C44]">
      <header className="border-b border-[#132C44]/10 bg-[#F6EFDF]/90 backdrop-blur sticky top-0 z-30">
        <div className="max-w-6xl mx-auto px-5 lg:px-8 h-14 flex items-center justify-between">
          <Link
            to="/english-id"
            className="font-serif text-lg font-bold tracking-tight flex items-center gap-2"
            data-testid="eid-brand"
          >
            <span className="h-7 w-7 rounded-md bg-[#132C44] text-[#F6EFDF] flex items-center justify-center text-[11px] font-bold">
              ID
            </span>
            <span>English ID</span>
            <span className="hidden sm:inline text-[11px] text-[#132C44]/60 font-sans font-normal ml-1">
              · Pinar English Academy
            </span>
          </Link>
          <div className="flex items-center gap-3 text-[13px]">
            {user ? (
              <>
                <span className="hidden sm:inline text-[#132C44]/70" data-testid="eid-user-email">
                  {user.email}
                </span>
                <span className="text-[10px] uppercase tracking-widest bg-[#8AA986]/20 text-[#4F6B47] px-2 py-0.5 rounded-full font-semibold">
                  {{ admin: "Admin", family: "Familia" }[user.role] || "Alumno/a"}
                </span>
                <button
                  onClick={doLogout}
                  className="px-3 py-1.5 rounded-full bg-[#132C44] text-[#F6EFDF] text-[12px] font-semibold hover:bg-[#1E3A5F]"
                  data-testid="eid-logout-btn"
                >
                  Salir
                </button>
              </>
            ) : (
              !loc.pathname.endsWith("/login") && (
                <Link
                  to="/english-id/login"
                  className="px-3 py-1.5 rounded-full border border-[#132C44]/30 text-[12px] font-semibold hover:bg-[#132C44] hover:text-[#F6EFDF]"
                  data-testid="eid-login-link"
                >
                  Ingresar
                </Link>
              )
            )}
          </div>
        </div>
      </header>
      <main className="max-w-6xl mx-auto px-5 lg:px-8 py-8">
        <Outlet />
      </main>
    </div>
  );
}
